<template>
  <div class="notification" id="notification" :class="classVariant">
    <p v-if="notification.status === 'success'">Success <span v-if="notification.message !== ''">{{notification.message}}</span></p>
    <p v-else-if="notification.status === 'validate'">
      <b>Please correct the following error(s):</b>
      <ul>
        <li v-for="(error, index) in notification.message" :key="index" v-html="error"></li>
      </ul>
    </p>
    <p v-else>
      Error:  <span v-html="notification.message"></span>
    </p>
  </div>
</template>

<script>

export default {
  name: 'notification',
  data () {
    return {
    }
  },
  computed: {
    classVariant () {
      return {
        'success': this.notification.status === 'success',
        'error': this.notification.status === 'fail' || this.notification.status === 'validate'
      }
    }
  },
  created () {
  },
  mounted () {
  },
  props: [
    'notification'
  ],
  watch: {
    notification: {
      deep: true,
      handler (newValue, oldValue) {
      }
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
  .notification {
    padding: 15px;
    width: 100%;
    z-index: 6;
    min-height: 100px;
    &.success{
      border: 1px solid green;
      color: green;
      background: lighten(green, 70%);
    }
    &.error{
      border: 1px solid #f00;
      color: #f00;
      background: lighten(#f00, 45%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/notification.vue